export const TITLE_TABLE_INTERESTED = [
  {
    key: 'portfolioName',
    label: 'dashboard.interested.companyList',
  },
  {
    key: 'totalCompany',
    label: 'dashboard.interested.companies',
  },
  {
    key: 'description',
    label: 'dashboard.interested.description',
  },
]

export const TITLE_TABLE_SUGGEST_DETAIL = [
  {
    key: 'organizationName',
    label: 'dashboard.suggestDetail.companyName',
  },
]

export const TITLE_TABLE_SUGGEST_DETAIL_SELECTED = [
  {
    key: 'organizationName',
    label: 'dashboard.suggestDetail.selectedCompanies',
  },
]

export const NUMBER_ITEM_TABLE = 10
